import styled from "styled-components";

export const SystemLayoutStyled = styled.div`
  .desktop_system_layout {
    .body_mainlayout {
      margin: auto;
      width: 100%;
      max-width: ${({ theme }) => theme.ETC.BODY_CONTAINER_WIDTH};
      min-height: calc(100vh - 400px);
    }
  }
  .mobile_system_layout {
    position: relative;
    padding: 24px 0 0 0;
    margin: auto;
    border-left: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    border-right: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    background-color: ${({ theme }) => theme.COLORS.WHITE_1};
    .header_mainlayout {
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
      .lang_noti_block {
        padding-left: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .body_mainlayout {
      min-height: calc(100vh - 175px);
    }
    .menu_mainlayout {
      position: sticky;
      bottom: 0;
      width: 100%;
      z-index: 99;
    }
  }
`;

